import { render, staticRenderFns } from "./MaterialNowList.vue?vue&type=template&id=e2ba8eec&scoped=true"
import script from "./MaterialNowList.vue?vue&type=script&lang=js"
export * from "./MaterialNowList.vue?vue&type=script&lang=js"
import style0 from "./MaterialNowList.vue?vue&type=style&index=0&id=e2ba8eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ba8eec",
  null
  
)

export default component.exports